// @ts-nocheck — small page, types added when touched again later
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useViewer } from "../lib/data/viewer";
// Phase 4e — IT/EN parity.
import { useLang } from "../lib/lang";
// Phase B1 — layout primitive.
import Page from "../components/ui/Page";

/* src/views/NotFound.tsx — Phase 8 catch-all.
   Previously the wildcard route silently redirected to /forecast/italy.
   That hid bad links — bookmarked-old-URL behavior is fine, but
   typos / dead deep-links looked like the dashboard always rendered.
   Now we show a real 404 with the path that was tried + helpful
   navigation. */

export default function NotFound() {
  const loc = useLocation();
  const { viewer } = useViewer();
  const isAdmin = !!viewer?.isAdmin;
  const lang = useLang();

  // Phase A2: title + ViewerChip moved to the global AppTopbar.
  // Phase B1: outer wrapper graduated to <Page>.
  return (
    <Page width="compact">
      <p style={{ color: "var(--text-muted)", marginTop: 0, marginBottom: "var(--space-4)" }}>
        {lang === "it" ? "Niente si trova a" : "Nothing lives at"}
        <code style={{ margin: "0 var(--space-1)", padding: "0 var(--space-1)", background: "var(--bg-2)", borderRadius: 4, fontFamily: "var(--font-mono)" }}>
          {loc.pathname}
        </code>.
        {lang === "it"
          ? " Forse è stata spostata, o il link è sbagliato."
          : " It may have moved, or the link is wrong."}
      </p>

      <div style={{ display: "flex", flexDirection: "column", gap: "var(--space-2)", marginTop: "var(--space-5)" }}>
        <Link to="/forecast/italy" style={{ color: "var(--accent)", textDecoration: "none", fontSize: "var(--fs-body)" }}>
          {lang === "it" ? "→ Previsioni Italia" : "→ Italy forecast"}
        </Link>
        {viewer && (
          <Link to="/me" style={{ color: "var(--accent)", textDecoration: "none", fontSize: "var(--fs-body)" }}>
            {lang === "it" ? "→ Il mio profilo" : "→ My profile"}
          </Link>
        )}
        {isAdmin && (
          <>
            <Link to="/admin/users" style={{ color: "var(--accent)", textDecoration: "none", fontSize: "var(--fs-body)" }}>
              {lang === "it" ? "→ Utenti" : "→ Users"}
            </Link>
            <Link to="/admin/audit" style={{ color: "var(--accent)", textDecoration: "none", fontSize: "var(--fs-body)" }}>
              {lang === "it" ? "→ Registro modifiche" : "→ Audit log"}
            </Link>
          </>
        )}
      </div>
    </Page>
  );
}
